

















































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppCheckRound from '@/components/AppCheckRound.vue'
import AppFileInput from '@/components/AppFileInput.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import { USER_QUERY, ADD_USER_MEDIA } from '@/gql/user'
import { Common, Upload } from '@/mixins'

const UNLINK_SOCIAL = gql`
mutation ($input: UpdateUserInput!) {
  updateUser(input: $input) {
    success
    message
    user {
      id
      youtubeUrl
      instagramUrl
    }
  }
}`

@Component({
  components: {
    AppCheckRound,
    AppFileInput,
    AppRouterLink,
    AppTitleBar
  },
  apollo: {
    user: {
      query: USER_QUERY
    }
  }
})
export default class extends Mixins(Common, Upload) {
  user = { youtubeUrl: '', instagramUrl: '' }

  async onSelectImage (selectedFile: File, mediaOwnerUseType: string) {
    const filename = await this.uploadFile(selectedFile, {
      mediaType: 'IMAGE',
      mediaOwnerType: 'USER',
      mediaOwnerUseType
    })

    const { data } = await this.$apollo.mutate({
      mutation: ADD_USER_MEDIA,
      variables: {
        input: {
          filename,
          mediaType: 'IMAGE',
          mediaOwnerUseType
        }
      }
    })

    await this.showToast(data.addUserMedia.message)
  }

  get instagramAuthorizeUrl () {
    const params = new URLSearchParams({
      client_id: process.env.VUE_APP_INSTAGRAM_APP_ID || '',
      redirect_uri: `${process.env.VUE_APP_WEB_ORIGIN}/oauth/instagram`,
      scope: 'user_profile',
      response_type: 'code',
      state: this.appsflyerId
    }).toString()

    return `https://www.instagram.com/oauth/authorize?${params}`
  }

  get youtubeAuthorizeUrl () {
    const params = new URLSearchParams({
      client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID || '',
      redirect_uri: `${process.env.VUE_APP_WEB_ORIGIN}/oauth/youtube`,
      scope: 'https://www.googleapis.com/auth/youtube.readonly',
      response_type: 'code',
      access_type: 'offline',
      state: this.appsflyerId
    }).toString()

    return `https://accounts.google.com/o/oauth2/auth?${params}`
  }

  async onClickInstagram () {
    if (!this.user.instagramUrl) {
      location.href = this.instagramAuthorizeUrl
    } else {
      const result = confirm('인스타그램 연결을 해제하시겠습니까?')
      if (!result) return

      const { data } = await this.$apollo.mutate({
        mutation: UNLINK_SOCIAL,
        variables: { input: { instagramUrl: '' } }
      })
      await this.showToast(data.updateUser.message)
    }
  }

  async onClickYoutube () {
    if (!this.user.youtubeUrl) {
      location.href = this.youtubeAuthorizeUrl
    } else {
      const result = confirm('유튜브 연결을 해제하시겠습니까?')
      if (!result) return

      const { data } = await this.$apollo.mutate({
        mutation: UNLINK_SOCIAL,
        variables: { input: { youtubeUrl: '' } }
      })
      await this.showToast(data.updateUser.message)
    }
  }
}
